import React, { useEffect, useState } from 'react';
import styles from '../BasicCleanupsFilter/BasicCleanupsFilter.module.scss';
// import styles from './AdvancedCleanupsFilter.module.scss';
import AdvancedBasicCategories from './AdvancedBasicCategories/AdvancedBasicCategories';
import { CalciteButton, CalcitePanel, CalciteRadioButton } from '@esri/calcite-components-react';
import AdvancedInstitutionalControls from './AdvancedInstitutionalControls/AdvancedInstitutionalControls';
import AdvancedEngineeringControls from './AdvancedEngineeringControls/AdvancedEngineeringControls';
import AdvancedEnvironmentalIndicators from './AdvancedEnvironmentalIndicators/AdvancedEnvironmentalIndicators';
import ClearAllButton from '../../ClearAllButton/ClearAllButton';
import Extent from '@arcgis/core/geometry/Extent';

/*
Structure for the advanced cleanups filter component:
- this is the parent component α
- there are 4 subcomponents β(i) that contain the categories of advanced searching
- each subcomponent β(i) has their own subcomponents γ(j) that contain the checkbox divs for each subcategory (these are the leaf components)

  - the parent component α
    - recieves and passes sitesLayer down the component tree
    - hosts the matchesAny and signalClear hooks, which are passed down the entire component tree
      - matchesAny (true for ANY, false for ALL) indicates to the components whether one or all search parameter must be met
      - signalClear updates will re-render every component
    - contains updater functions that are passed down to each β component
      - each function updates the array storing the query parameters
    - updates the definition expression of the sites layer

  - the subcomponents β
    - recieve sitesLayer, matchesAny, and signalClear as props, and passes them down to the leaf components
    - hosts arrays in hooks that store data retrieved from leaf components
    - contains updater functions (similar to the parent component) that are passed down to leaf components, so that they can update the respective arrays
    - have their own functions to update the parent component with query parameters from their section
  
  - the leaf components γ
    - render the checkboxes
    - re-render when matchesAny or signalClear update
    - store query parameters that match the parameter value coupled with a checkbox
    - pass up object id values to the β component, which passes the query parameters within its scope up to the α component
    */

const AdvancedCleanupsFilter = (props) => {
  // matchesAny = true for matches ANY param, = false for matches ALL params, gets updated on radio button clicks
  let [matchesAny, setMatchesAny] = useState<boolean>(true);
  // signalClear value changes any time the clear button is clicked, re-rendering checkbox components
  const [signalClear, setSignalClear] = useState<number>(Math.random());
  // all of these 
  const [basicParams, setBasicParams] = useState<Array<string>>([]);
  const [institutionalParams, setInstitutionalParams] = useState<Array<string>>([]);
  const [engineeringParams, setEngineeringParams] = useState<Array<string>>([]);
  const [environmentalParams, setEnvironmentalParams] = useState<Array<string>>([]);

  // called by AdvancedBasicCategories.updateAllbasicParams()
  const updateBasicParams = (paramArray) => {
    // advancedBasicParams = paramArray;
    setBasicParams(paramArray);
  }

  // called by AdvancedInstitutionalControls.updateInstitutionalParams()
  const updateInstitutionalParams = (objectIds) => {
    setInstitutionalParams(objectIds);
  }

  // called by AdvancedEnvironmentalControls.updateEnvironmentalParams()
  const updateEnvironmentalParams = (objectIds) => {
    setEnvironmentalParams(objectIds);
  }

  // called by AdvancedEngineeringControls.updateEngineeringParams()
  const updateEngineeringParams = (objectIds) => {
    setEngineeringParams(objectIds);
  }

  const updateDefinitionExpression = () => {
    let defStr;
    let paramArray: Array<any> = [
      ...basicParams,
      ...engineeringParams,
      ...environmentalParams,
      ...institutionalParams
    ];
    if (paramArray.length > 0) {
      if (matchesAny === true) {
        defStr = paramArray.join(' OR ');
      } else if (matchesAny === false) {
        defStr = paramArray.join(' AND ');
      }
    } else {
      defStr = "1=0";
    }
    props.sitesLayerView.filter = {
      where: defStr
    }
    // props.sitesLayer.definitionExpression = defStr;
  }

  const reAlignMap = () => {
    if (props.sitesLayer.definitionExpression !== '1=0') {
      props.sitesLayer.queryExtent().then((response) => {
        if (response.extent.ymin > -19914421.299593817 && response.extent.ymax < 20056431.422842726) {
          props.view.goTo(response.extent).catch((error) => {
            console.error(error);
          });
        } else {
          let safeExtent = new Extent({
            "spatialReference": {
              "wkid": 102100
            },
            "xmin": 82084561.49065825,
            "ymin": -4424310.017654857,
            "xmax": 117150201.0905301,
            "ymax": 14830483.155489063,

          })
          props.view.goTo(safeExtent).catch((error) => { console.error(error); })
        }
      });
    }
  }
  const matchesAnyButton = matchesAny === true ? <CalciteRadioButton checked value="matchesAny" onCalciteRadioButtonChange={() => { setMatchesAny(!matchesAny) }} />
  : <CalciteRadioButton value="matchesAny" onCalciteRadioButtonChange={() => { setMatchesAny(!matchesAny) }} />;

  const matchesAllButton = matchesAny === false ? <CalciteRadioButton checked value="matchesAll" onCalciteRadioButtonChange={() => { setMatchesAny(!matchesAny) }} />
  : <CalciteRadioButton value="matchesAll" onCalciteRadioButtonChange={() => { setMatchesAny(!matchesAny) }} />;

  useEffect(() => { }, [signalClear, matchesAny, basicParams, institutionalParams, engineeringParams, environmentalParams])

  return (
    <>
      <div>
        <CalciteButton className={styles.FilterAndZoomButtons} onClick={() => { updateDefinitionExpression() }} iconStart={"layer-filter"}>Filter</CalciteButton>
        {/* <CalciteButton className={styles.FilterAndZoomButtons} onClick={() => { reAlignMap() }} iconStart={"zoom-to-object"}>Re-Align Map</CalciteButton> */}
        <ClearAllButton handleClick={() => { setSignalClear(Math.random()); props.sitesLayerView.filter = { where: "1=0" } }} />
        {/* <ClearAllButton handleClick={() => { setSignalClear(Math.random()); props.sitesLayer.definitionExpression = "1=0" }} /> */}
        <div className={styles.SectionTitleDivs}>
          {/* <CalciteRadioButton checked={matchesAny === true} value="matchesAny" onCalciteRadioButtonChange={() => { setMatchesAny(!matchesAny) }} /> */}
          {matchesAnyButton}
          <label className={styles.FilterSectionLabels}>Include cleanups that match ANY of the checked checkboxes below.</label>
        </div>
        <div className={styles.SectionTitleDivs}>
          {/* <CalciteRadioButton checked={matchesAny === false} value="matchesAll" onCalciteRadioButtonChange={() => { setMatchesAny(!matchesAny) }} /> */}
         {matchesAllButton}
          <label className={styles.FilterSectionLabels}>Include cleanups that match ALL of the checked checkboxes below.</label>
        </div>
      </div>

      <CalcitePanel className={styles.ParentPanel}>
        <label className={styles.SectionLabels} >Basic Categories</label>
        <AdvancedBasicCategories sitesLayer={props.sitesLayer} matchesAny={matchesAny}
          updateBasicParams={updateBasicParams} signalClear={signalClear} />
      </CalcitePanel>

      <CalcitePanel className={styles.ParentPanel}>
        <label className={styles.SectionLabels}>Institutional Controls</label>
        <AdvancedInstitutionalControls sitesLayer={props.sitesLayer} matchesAny={matchesAny}
          updateInstitutionalParams={updateInstitutionalParams} signalClear={signalClear} />
      </CalcitePanel>

      <CalcitePanel className={styles.ParentPanel}>
        <label className={styles.SectionLabels}>Engineering Controls</label>
        <AdvancedEngineeringControls sitesLayer={props.sitesLayer} matchesAny={matchesAny}
          updateEngineeringParams={updateEngineeringParams} signalClear={signalClear} />
      </CalcitePanel>

      <CalcitePanel className={styles.ParentPanel}>
        <label className={styles.SectionLabels}>Environmental Indicators</label>
        <AdvancedEnvironmentalIndicators sitesLayer={props.sitesLayer} matchesAny={matchesAny}
          updateEnvironmentalParams={updateEnvironmentalParams} signalClear={signalClear} />
      </CalcitePanel>
    </>
  );
}

export default AdvancedCleanupsFilter;